export * from './success-buy.component';
